// src/components/base/Icon/SvgRegistry.tsx
import type { ComponentChildren } from 'preact';

// Registry entries provide the SVG elements plus icon-specific defaults.
export interface SvgDefinition {
  elements: ComponentChildren;
  viewBox?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
}

export const SvgPaths = {
  swap: {
    elements: (
      <path d="M19 8.9c0 2-1.6 3.6-3.6 3.6H8.1c-1.4 0-2.6 1.1-2.6 2.6s1.1 2.6 2.6 2.6h4.3l-1.1-1.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.3 2.3-2.3 2.3c-.1.1-.2.1-.4.1s-.3 0-.4-.1c-.2-.2-.2-.5 0-.7l1.1-1.1H8.1c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6h7.3c1.4 0 2.6-1.1 2.6-2.6s-1.1-2.6-2.6-2.6H11l1.1 1.1c.2.2.2.5 0 .7-.1.1-.2.1-.4.1s-.3 0-.4-.1L9.1 5.9l2.3-2.3c.2-.2.5-.2.7 0s.2.5 0 .7L11 5.4h4.5C17.4 5.4 19 7 19 8.9z" />
    ),
    fill: 'currentColor',
  },
  chevronLeft: {
    elements: (
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="st0"
        d="M14.2,16.7c-0.1,0-0.3,0-0.4-0.1L9.3,12l4.6-4.6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L10.7,12l3.9,3.9   c0.2,0.2,0.2,0.5,0,0.7C14.5,16.7,14.4,16.7,14.2,16.7z"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  chevronRight: {
    elements: (
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="st0"
        d="M9.8,7.3c0.1,0,0.3,0,0.4,0.1l4.6,4.6l-4.6,4.6c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7l3.9-3.9L9.4,8.1   c-0.2-0.2-0.2-0.5,0-0.7C9.5,7.3,9.6,7.3,9.8,7.3z"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  chevronUp: {
    elements: (
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="st0"
        d="M7.3,14.2c0-0.1,0-0.3,0.1-0.4L12,9.3l4.6,4.6c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0L12,10.7l-3.9,3.9   c-0.2,0.2-0.5,0.2-0.7,0C7.3,14.5,7.3,14.4,7.3,14.2z"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  chevronDown: {
    elements: (
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="st0"
        d="M16.7,9.8c0,0.1,0,0.3-0.1,0.4L12,14.7l-4.6-4.6c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l3.9,3.9l3.9-3.9   c0.2-0.2,0.5-0.2,0.7,0C16.7,9.5,16.7,9.6,16.7,9.8z"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  mapPin: {
    elements: (
      <path d="M12 21.5a.5.5 0 0 1-.35-.15l-5.28-5.27a8 8 0 1 1 11.25 0l-5.27 5.27a.5.5 0 0 1-.35.15zm0-18a7 7 0 0 0-4.92 11.87L12 20.29l4.92-4.92A7 7 0 0 0 12 3.5zm0 10a3.11 3.11 0 1 1 3.11-3.11A3.12 3.12 0 0 1 12 13.51zm0-5.23a2.11 2.11 0 1 0 2.11 2.12A2.12 2.12 0 0 0 12 8.29z"></path>
    ),
    fill: 'currentColor',
  },
  locationArrow: {
    elements: (
      <path d="M17.35 6.65a.5.5 0 0 0-.52-.12l-11 4a.5.5 0 0 0 0 .93l4.8 1.92 1.92 4.8a.5.5 0 0 0 .46.31.5.5 0 0 0 .46-.33l4-11a.5.5 0 0 0-.12-.51zM13 16.6l-1.51-3.78a.5.5 0 0 0-.28-.28L7.4 11l8.76-3.19z"></path>
    ),
    fill: 'currentColor',
  },
  tooltip: {
    elements: (
      <path d="M12 4.9h.01c1.6 0 3.1.6 4.2 1.8 1.2 1.2 1.8 2.7 1.8 4.3 0 1.8-.8 3.5-2.2 4.6-.8.6-1.2 1.4-1.2 2.3v.6c0 1.4-1.2 2.6-2.6 2.6s-2.6-1.2-2.6-2.6v-.8c0-.8-.4-1.5-1.1-2.1-1.5-1.1-2.3-2.9-2.3-4.8.1-3.2 2.7-5.9 6-5.9Zm1.6 13.6v-.8h-3.2v.8c0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6Zm.2-1.7c.3-.8.7-1.5 1.4-2 1.1-1 1.8-2.4 1.8-3.9 0-1.4-.5-2.7-1.5-3.6A4.914 4.914 0 0 0 12 5.9h-.1c-2.6 0-4.9 2.3-4.9 4.9 0 1.6.7 3 1.9 4 .7.5 1.1 1.2 1.3 2h3.6Zm-.8-9.3c.3 0 .5.2.5.5s-.2.5-.5.5c-1.6 0-2.9 1.3-2.9 2.9 0 .3-.2.5-.5.5s-.5-.2-.5-.5C9.1 8.7 10.9 7.5 13 7.5Z" />
    ),
    fill: 'currentColor',
  },
  newTab: {
    elements: (
      <path d="M19.0002 5V9.25C19.0002 9.39 18.9402 9.51 18.8502 9.6C18.7602 9.69 18.6302 9.75 18.5002 9.75C18.2202 9.75 18.0002 9.53 18.0002 9.25V6.71L11.9302 12.78C11.7302 12.98 11.4202 12.98 11.2202 12.78C11.0202 12.58 11.0202 12.27 11.2202 12.07L17.2902 6H14.7502C14.4702 6 14.2502 5.78 14.2502 5.5C14.2502 5.22 14.4702 5 14.7502 5H19.0002ZM18.0002 17.64V13.35C18.0002 13.07 17.7802 12.85 17.5002 12.85C17.2202 12.85 17.0002 13.07 17.0002 13.35V17.64C17.0002 17.84 16.8402 18 16.6402 18H6.35023C6.15023 18 5.99023 17.84 5.99023 17.64V7.36C5.99023 7.16 6.15023 7 6.35023 7H10.6402C10.9202 7 11.1402 6.78 11.1402 6.5C11.1402 6.22 10.9202 6 10.6402 6H6.35023C5.60023 6 4.99023 6.61 4.99023 7.36V17.65C4.99023 18.4 5.60023 19.01 6.35023 19.01H16.6402C17.3902 19.01 18.0002 18.4 18.0002 17.65V17.64Z" />
    ),
    fill: 'currentColor',
    viewBox: '0 0 24 24',
  },
  timetable: {
    elements: (
      <path
        d="M10.25 10.25H7.25V9.25H10.25V10.25ZM7.25 15.25V16.25H9.78C9.81 15.91 9.87001 15.57 9.95001 15.25H7.25ZM7.25 17.25V18.25H9.95001C9.87001 17.93 9.81 17.59 9.78 17.25H7.25ZM10.25 7.25H7.25V8.25H10.25V7.25ZM6.25 19.25V5.25H15.25V10.78C15.42 10.77 15.58 10.75 15.75 10.75C15.92 10.75 16.08 10.76 16.25 10.78V4.75C16.25 4.47 16.03 4.25 15.75 4.25H5.75C5.47 4.25 5.25 4.47 5.25 4.75V19.75C5.25 20.03 5.47 20.25 5.75 20.25H10.89C10.66 19.94 10.47 19.6 10.31 19.25H6.26001H6.25ZM11.25 12.25H11.79C12.25 11.84 12.78 11.5 13.35 11.25H11.24V12.25H11.25ZM10.25 11.25H7.25V12.25H10.25V11.25ZM14.25 9.25H11.25V10.25H14.25V9.25ZM10.25 13.25H7.25V14.25H10.25V13.25ZM14.25 7.25H11.25V8.25H14.25V7.25ZM16.25 16.54V14.25C16.25 13.97 16.03 13.75 15.75 13.75C15.47 13.75 15.25 13.97 15.25 14.25V16.96L16.46 18.17C16.56 18.27 16.69 18.32 16.81 18.32C16.93 18.32 17.07 18.27 17.16 18.17C17.36 17.97 17.36 17.66 17.16 17.46L16.24 16.54H16.25ZM20.75 16.75C20.75 19.51 18.51 21.75 15.75 21.75C12.99 21.75 10.75 19.51 10.75 16.75C10.75 13.99 12.99 11.75 15.75 11.75C18.51 11.75 20.75 13.99 20.75 16.75ZM19.75 16.75C19.75 14.54 17.96 12.75 15.75 12.75C13.54 12.75 11.75 14.54 11.75 16.75C11.75 18.96 13.54 20.75 15.75 20.75C17.96 20.75 19.75 18.96 19.75 16.75Z"
        fill-opacity="0.95"
      />
    ),
    fill: 'currentColor',
  },
  bus: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 1C17.2091 1 19 2.79086 19 5V19C19 19.7398 18.5971 20.3835 18 20.7295V21.5C18 22.3284 17.3284 23 16.5 23H15.5C14.6716 23 14 22.3284 14 21.5V21H10V21.5C10 22.3284 9.32843 23 8.5 23H7.5C6.67157 23 6 22.3284 6 21.5V20.7295C5.4029 20.3835 5 19.7398 5 19V5C5 2.79086 6.79086 1 9 1H15ZM8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18ZM16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18ZM8 9C7.44772 9 7 9.44772 7 10V15.3232C7.00011 15.732 7.24933 16.0991 7.62891 16.251L11.2568 17.7031C11.7337 17.8939 12.2663 17.8939 12.7432 17.7031L16.3711 16.251C16.7507 16.0991 16.9999 15.732 17 15.3232V10C17 9.44772 16.5523 9 16 9H8ZM9 3C7.89543 3 7 3.89543 7 5V6C7 6.55228 7.44772 7 8 7H16C16.5523 7 17 6.55228 17 6V5C17 3.89543 16.1046 3 15 3H9Z"
        fill-opacity="0.95"
      ></path>
    ),
    fill: 'currentColor',
  },
  busLocation: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 1C17.2091 1 19 2.79086 19 5V19C19 19.7398 18.5971 20.3835 18 20.7295V21.5C18 22.3284 17.3284 23 16.5 23H15.5C14.6716 23 14 22.3284 14 21.5V21H10V21.5C10 22.3284 9.32843 23 8.5 23H7.5C6.67157 23 6 22.3284 6 21.5V20.7295C5.4029 20.3835 5 19.7398 5 19V5C5 2.79086 6.79086 1 9 1H15ZM8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18ZM16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18ZM8 9C7.44772 9 7 9.44772 7 10V15.3232C7.00011 15.732 7.24933 16.0991 7.62891 16.251L11.2568 17.7031C11.7337 17.8939 12.2663 17.8939 12.7432 17.7031L16.3711 16.251C16.7507 16.0991 16.9999 15.732 17 15.3232V10C17 9.44772 16.5523 9 16 9H8ZM9 3C7.89543 3 7 3.89543 7 5V6C7 6.55228 7.44772 7 8 7H16C16.5523 7 17 6.55228 17 6V5C17 3.89543 16.1046 3 15 3H9Z"
      ></path>
    ),
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1',
  },
  ferry: {
    elements: (
      <>
        <path
          d="M14.8168 19C16.4438 19.0001 17.2824 19.8002 18.0209 20.5068C18.7092 21.1601 19.2475 21.6669 20.3988 21.667H20.3744C20.7247 21.6671 21.0002 21.9599 21.0004 22.333C21.0004 22.7063 20.7248 22.9999 20.3744 23C18.7471 23 17.9078 22.1998 17.1693 21.4932C16.481 20.84 15.9553 20.333 14.7914 20.333C13.6274 20.333 13.0893 20.84 12.4134 21.4932C11.6874 22.1998 10.8356 23 9.20837 23C7.58128 22.9999 6.74275 22.1998 6.00426 21.4932C5.31592 20.8399 4.7776 20.3331 3.62633 20.333C3.27595 20.333 3.00052 20.0402 3.00036 19.667C3.00036 19.2937 3.27585 19 3.62633 19C5.26581 19.0001 6.10467 19.8002 6.84313 20.5068C7.53146 21.16 8.05714 21.667 9.22106 21.667C10.385 21.667 10.9232 21.16 11.599 20.5068C12.3375 19.8002 13.1895 19 14.8168 19Z"
          fill-opacity="0.95"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.0004 0.75C12.4144 0.75019 12.7504 1.0859 12.7504 1.5V3H16.2103C17.2292 3.0002 18.0851 3.76656 18.1976 4.7793L18.7924 10.1318L21.0736 10.8477C21.5894 11.0098 21.8825 11.5528 21.7357 12.0732L19.5394 19.8584C19.47 19.8016 19.3915 19.7332 19.2982 19.6475L19.0541 19.4189C18.2848 18.6827 17.0698 17.5002 14.8168 17.5C12.5637 17.5 11.3375 18.6816 10.5629 19.4229L10.557 19.4277C10.1985 19.7742 10.0247 19.9293 9.84997 20.0293C9.72667 20.0997 9.55884 20.1669 9.22106 20.167C8.88467 20.1669 8.72231 20.0999 8.60094 20.0303C8.42339 19.9284 8.2522 19.7758 7.88024 19.4229C7.15666 18.7305 6.04401 17.6467 4.03942 17.5137L3.79528 17.5049L2.26403 12.0732C2.11718 11.5527 2.41109 11.0097 2.92712 10.8477L5.20739 10.1309L5.80309 4.7793C5.91565 3.76647 6.77133 3.00002 7.7904 3H11.2504V1.5C11.2504 1.08579 11.5861 0.75 12.0004 0.75ZM8.63805 5C8.11663 5.00019 7.68324 5.40108 7.64196 5.9209L7.36071 9.45508L10.8021 8.37598C11.5818 8.13133 12.418 8.13133 13.1976 8.37598L16.639 9.45605L16.3588 5.9209C16.3175 5.40118 15.8839 5.00037 15.3627 5H8.63805Z"
          fill-opacity="0.95"
        ></path>
      </>
    ),
    fill: 'currentColor',
  },
  train: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 1C15.866 1 19 4.13401 19 8V14C19 15.4741 17.9366 16.6987 16.5351 16.9512L19.624 21.584C19.8538 21.9286 19.7606 22.3943 19.416 22.624C19.0713 22.8538 18.6057 22.7606 18.3759 22.416L17.2656 20.75H6.73434L5.62399 22.416C5.39422 22.7606 4.92859 22.8538 4.58395 22.624C4.23938 22.3942 4.14622 21.9286 4.37595 21.584L7.46384 16.9512C6.06291 16.6983 4.99997 15.4738 4.99997 14V8C4.99997 4.13402 8.13399 1.00002 12 1ZM9.23434 17L7.73434 19.25H16.2656L14.7656 17H9.23434ZM7.99997 13C7.4477 13 6.99997 13.4477 6.99997 14C6.99997 14.5523 7.4477 15 7.99997 15C8.55225 15 8.99997 14.5523 8.99997 14C8.99997 13.4477 8.55225 13 7.99997 13ZM16 13C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13ZM12 3C9.23856 3.00002 6.99997 5.23859 6.99997 8V9.82031C6.99999 10.6681 7.53458 11.4237 8.33395 11.7061L11.0019 12.6475C11.6478 12.8753 12.3521 12.8753 12.998 12.6475L15.666 11.7061C16.4654 11.4237 16.9999 10.6681 17 9.82031V8C17 5.23858 14.7614 3 12 3Z"
        fill-opacity="0.95"
      ></path>
    ),
    fill: 'currentColor',
  },
  coach: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.75 3C18.2352 3.00013 20.25 5.0148 20.25 7.5V17.25C20.25 18.4598 19.5324 19.4991 18.501 19.9736V20.25C18.501 21.0783 17.8293 21.7499 17.001 21.75H15.9385C15.1618 21.75 14.5231 21.1597 14.4463 20.4033L14.4385 20.25H9.56348L9.55566 20.4033C9.47888 21.1596 8.84002 21.7499 8.06348 21.75H7.00098C6.17255 21.75 5.50098 21.0784 5.50098 20.25V19.9746C4.46853 19.5005 3.75 18.4605 3.75 17.25V7.5C3.75 5.01477 5.76479 3.00008 8.25 3H15.75ZM17.2822 16.2812C16.7299 16.2812 16.2822 16.729 16.2822 17.2812C16.2822 17.8335 16.7299 18.2812 17.2822 18.2812C17.8344 18.2811 18.2822 17.8335 18.2822 17.2812C18.2822 16.729 17.8344 16.2814 17.2822 16.2812ZM6.93848 16.0625C6.38619 16.0625 5.93848 16.5102 5.93848 17.0625C5.93848 17.6148 6.38619 18.0625 6.93848 18.0625C7.49065 18.0624 7.93848 17.6147 7.93848 17.0625C7.93848 16.5103 7.49065 16.0626 6.93848 16.0625ZM8.25 5.25C7.00736 5.25 6 6.25736 6 7.5V13.2109C6.00018 13.836 6.38831 14.3957 6.97363 14.6152L10.9463 16.1055C11.6254 16.3602 12.3746 16.3602 13.0537 16.1055L17.0264 14.6152C17.6117 14.3957 17.9998 13.836 18 13.2109V7.5C18 6.25736 16.9926 5.25 15.75 5.25H8.25Z"
        fill-opacity="0.95"
      ></path>
    ),
    fill: 'currentColor',
  },
  tram: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5721 1.00977C15.0299 1.05528 15.4608 1.25782 15.7889 1.58594L16.0995 1.89648C16.2944 2.09168 16.2944 2.40832 16.0995 2.60352C15.9043 2.7987 15.5877 2.79853 15.3925 2.60352L15.0819 2.29297C14.9179 2.12899 14.7022 2.02771 14.4735 2.00488L14.3749 2H12.2635L11.1259 3.71191L12.2313 5.00488C15.988 5.12943 18.995 8.21305 18.995 12V17C18.995 18.4744 17.931 19.6971 16.5292 19.9492H15.7792L16.9432 22.2764C17.0665 22.5232 16.9662 22.8237 16.7196 22.9473C16.4727 23.0707 16.1723 22.9705 16.0487 22.7236L15.8124 22.25H8.17957L7.94324 22.7236C7.81981 22.9705 7.51925 23.0705 7.27234 22.9473C7.02535 22.8238 6.92521 22.5234 7.04871 22.2764L8.21277 19.9492H7.45984C6.05872 19.6965 4.995 18.4739 4.995 17V12C4.995 8.48075 7.59234 5.56838 10.9745 5.07422L10.3661 4.3623C10.0758 4.02266 10.0458 3.53135 10.2928 3.15918L11.0634 2H9.61707C9.35205 2.00006 9.09749 2.10564 8.91003 2.29297L8.59949 2.60352C8.40431 2.7987 8.08774 2.79853 7.89246 2.60352C7.69719 2.40825 7.69719 2.09175 7.89246 1.89648L8.203 1.58594C8.578 1.21107 9.08683 1.00006 9.61707 1H14.3749L14.5721 1.00977ZM8.67957 21.25H15.3124L14.662 19.9492H9.32996L8.67957 21.25ZM7.995 16C7.44283 16.0001 6.995 16.4478 6.995 17C6.995 17.5522 7.44284 17.9999 7.995 18C8.54727 18 8.99499 17.5523 8.995 17C8.995 16.4477 8.54728 16 7.995 16ZM15.995 16C15.4428 16.0001 14.995 16.4478 14.995 17C14.995 17.5522 15.4428 17.9999 15.995 18C16.5473 18 16.995 17.5523 16.995 17C16.995 16.4477 16.5473 16 15.995 16ZM11.995 7C9.2337 7.00014 6.995 9.23867 6.995 12V12.8203C6.99502 13.6682 7.53039 14.4238 8.32996 14.7061L10.9969 15.6475C11.6429 15.8753 12.3481 15.8754 12.994 15.6475L15.661 14.7061C16.4604 14.4238 16.995 13.6681 16.995 12.8203V12C16.995 9.23858 14.7564 7 11.995 7Z"
        fill-opacity="0.95"
      ></path>
    ),
    fill: 'currentColor',
  },
  tube: {
    elements: (
      <>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.0001 5C15.8659 5.00024 19.0001 8.13416 19.0001 12V17.0001C19.0001 18.4745 17.9352 19.6973 16.5333 19.9493H15.7833L16.9474 22.2765C17.0708 22.5234 16.9707 22.8239 16.7238 22.9474C16.4768 23.0709 16.1764 22.9706 16.0529 22.7238L15.6915 22.0001H8.30873L7.94741 22.7238C7.82393 22.9707 7.52345 23.0707 7.27651 22.9474C7.02953 22.8239 6.92942 22.5235 7.05287 22.2765L8.21694 19.9493H7.46498C6.06382 19.6967 5.0002 18.474 5.00014 17.0001V12C5.00014 8.13403 8.13418 5.00004 12.0001 5ZM8.80873 21.0001H15.1915L14.6662 19.9493H9.33412L8.80873 21.0001ZM8.00014 16.0001C7.44789 16.0002 7.00014 16.4479 7.00014 17.0001C7.00021 17.5523 7.44794 18.0001 8.00014 18.0001C8.55217 17.9999 9.00007 17.5522 9.00014 17.0001C9.00014 16.448 8.55222 16.0004 8.00014 16.0001ZM16.0001 16.0001C15.4479 16.0002 15.0001 16.4479 15.0001 17.0001C15.0002 17.5523 15.4479 18.0001 16.0001 18.0001C16.5522 17.9999 17.0001 17.5522 17.0001 17.0001C17.0001 16.448 16.5522 16.0004 16.0001 16.0001ZM12.0001 7C9.23876 7.00004 7.00014 9.2386 7.00014 12V12.8204C7.00022 13.6683 7.53462 14.4239 8.33412 14.7062L11.0011 15.6476C11.647 15.8755 12.3523 15.8755 12.9982 15.6476L15.6652 14.7062C16.4647 14.424 17.0001 13.6683 17.0001 12.8204V12C17.0001 9.23873 14.7614 7.00024 12.0001 7Z"
          fill-opacity="0.95"
        ></path>
        <path
          d="M3.65346 4.63879C8.26285 0.029407 15.7363 0.0295939 20.3458 4.63879C24.9553 9.24827 24.9553 16.7217 20.3458 21.3312C20.1506 21.5264 19.8341 21.5264 19.6388 21.3312C19.4438 21.1359 19.4437 20.8193 19.6388 20.6241C23.8578 16.4052 23.8578 9.56477 19.6388 5.34582C15.4198 1.12715 8.57935 1.12696 4.36049 5.34582C0.141652 9.56469 0.141826 16.4052 4.36049 20.6241C4.55575 20.8194 4.55575 21.1359 4.36049 21.3312C4.16523 21.5264 3.8487 21.5264 3.65346 21.3312C-0.955731 16.7217 -0.955903 9.24818 3.65346 4.63879Z"
          fill-opacity="0.95"
        ></path>
      </>
    ),
    fill: 'currentColor',
  },
  walkSlow: {
    elements: (
      <path
        class="st0"
        d="M11.4,6.6c0-0.7,0.6-1.3,1.3-1.3S14,5.9,14,6.6c0,0.7-0.6,1.3-1.3,1.3S11.4,7.3,11.4,6.6z M15.7,12.1
      c-0.3-0.1-1.9-0.9-1.9-0.9s-0.6-1.2-0.9-1.9c-0.3-0.6-0.5-0.8-0.9-0.8h-0.6c-0.3,0-0.4,0.1-0.6,0.2L9,10.1
      c-0.1,0.1-0.2,0.2-0.3,0.4l-0.4,2.4c-0.1,0.4,0.2,0.6,0.4,0.6c0.2,0,0.5-0.1,0.5-0.3C9.3,13,9.7,11,9.7,11l1.1-0.8
      c-0.2,0.8-0.4,1.8-0.4,2.1c-0.1,0.5,0.2,0.9,0.4,1.3c0.2,0.3,2.7,4.2,3,4.7c0.3,0.4,0.6,0.6,1.1,0.4c0.4-0.2,0.3-0.7,0.1-1.1
      c-0.2-0.4-2.7-4.5-2.7-4.5l0.4-1.8c0,0,0.3,0.4,0.4,0.7c0.1,0.1,0.1,0.2,0.3,0.3c0.2,0.1,1.4,0.6,1.7,0.8c0.3,0.1,0.7,0.2,0.8-0.1
      C16.1,12.5,15.9,12.2,15.7,12.1z M9.6,15.6c0,0-1.1,1.5-1.4,2c-0.2,0.3-0.4,0.7,0,1c0.4,0.3,0.8-0.1,1-0.3c0.2-0.2,1-1.4,1.3-1.7
      c0.2-0.2,0.2-0.4,0.3-0.5c0-0.1,0.2-0.6,0.3-0.9l-1-1.4L9.6,15.6z"
      ></path>
    ),
    fill: 'currentColor',
  },
  walkMedium: {
    elements: (
      <>
        <path
          class="st0"
          d="M10.3,14H6.8c-0.3,0-0.5-0.2-0.5-0.5S6.5,13,6.8,13h3.5c0.3,0,0.5,0.2,0.5,0.5S10.6,14,10.3,14z"
        ></path>
        <path
          class="st0"
          d="M8.3,11H4.8c-0.3,0-0.5-0.2-0.5-0.5S4.5,10,4.8,10h3.5c0.3,0,0.5,0.2,0.5,0.5S8.6,11,8.3,11z"
        ></path>
        <path
          class="st1"
          d="M14.6,6.6c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3S14.6,7.3,14.6,6.6z M18.9,12.1
      C18.6,12,17,11.2,17,11.2s-0.6-1.3-0.9-1.9c-0.3-0.6-0.5-0.8-0.9-0.8h-0.6c-0.3,0-0.4,0.1-0.6,0.2l-1.7,1.4
      c-0.1,0.1-0.2,0.2-0.3,0.4l-0.4,2.4c-0.1,0.4,0.1,0.5,0.4,0.6c0.2,0,0.5-0.1,0.5-0.3c0.1-0.2,0.4-2.2,0.4-2.2l1.1-0.8
      c-0.2,0.8-0.4,1.8-0.4,2.1c-0.1,0.5,0.2,0.9,0.4,1.3c0.2,0.3,2.7,4.2,3,4.6s0.6,0.6,1.1,0.4c0.4-0.2,0.3-0.7,0.1-1.1
      c-0.2-0.4-2.7-4.5-2.7-4.5l0.4-1.8c0,0,0.3,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.4,0.3c0.2,0.1,1.4,0.6,1.7,0.8c0.3,0.1,0.7,0.2,0.8-0.1
      C19.3,12.5,19.1,12.2,18.9,12.1L18.9,12.1z M12.8,15.6c0,0-1.1,1.5-1.4,2c-0.2,0.3-0.4,0.7,0,1c0.4,0.3,0.8-0.1,1-0.4
      c0.2-0.2,1-1.4,1.3-1.7c0.2-0.2,0.2-0.4,0.3-0.5c0-0.1,0.2-0.6,0.3-0.9l-1-1.4L12.8,15.6L12.8,15.6z"
        ></path>
      </>
    ),
    fill: 'currentColor',
  },
  walkFast: {
    elements: (
      <>
        <path
          class="st0"
          d="M14.9,6.6c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3C15.5,7.9,14.9,7.3,14.9,6.6z
      M19.2,12.1c-0.2-0.1-1.9-0.9-1.9-0.9s-0.6-1.3-0.9-1.9c-0.3-0.6-0.5-0.8-0.9-0.8h-0.6c-0.3,0-0.4,0.1-0.6,0.2l-1.7,1.4
      c-0.1,0.1-0.2,0.2-0.3,0.4l-0.4,2.4c-0.1,0.4,0.2,0.5,0.4,0.6c0.2,0,0.5-0.1,0.5-0.3c0.1-0.2,0.4-2.2,0.4-2.2l1.1-0.8
      c-0.2,0.8-0.4,1.8-0.4,2.1c-0.1,0.5,0.2,0.9,0.4,1.3c0.2,0.3,2.7,4.2,3,4.6c0.3,0.4,0.6,0.6,1.1,0.4c0.4-0.2,0.3-0.7,0.1-1.1
      c-0.2-0.4-2.7-4.5-2.7-4.5l0.4-1.8c0,0,0.3,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.3,0.3c0.2,0.1,1.4,0.6,1.7,0.8c0.3,0.1,0.7,0.2,0.8-0.1
      C19.6,12.5,19.4,12.2,19.2,12.1L19.2,12.1z M13.1,15.6c0,0-1.1,1.5-1.4,2c-0.2,0.3-0.4,0.7,0,1c0.4,0.3,0.8-0.1,1-0.4
      c0.2-0.2,1-1.4,1.3-1.7c0.2-0.2,0.2-0.4,0.3-0.5c0-0.1,0.2-0.6,0.3-0.9l-1-1.4L13.1,15.6L13.1,15.6z"
        ></path>
        <path d="M10,14.8H6.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H10c0.3,0,0.5,0.2,0.5,0.5S10.3,14.8,10,14.8z"></path>
        <path d="M8,11.8H4.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H8c0.3,0,0.5,0.2,0.5,0.5S8.3,11.8,8,11.8z"></path>
        <path d="M10,8.8H6.5C6.2,8.8,6,8.6,6,8.3s0.2-0.5,0.5-0.5H10c0.3,0,0.5,0.2,0.5,0.5S10.3,8.8,10,8.8z"></path>
      </>
    ),
    fill: 'currentColor',
  },
  check: {
    elements: (
      <path
        d="M0.5 4.66003L3.92001 8.08008L10.5 0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    ),
    viewBox: '0 0 16 16',
    stroke: 'currentColor',
    strokeWidth: '1.5',
  },
  rti: {
    elements: (
      <g>
        <path
          d="M8.0002 9.29995C8.71817 9.29995 9.3002 8.71792 9.3002 7.99995C9.3002 7.28198 8.71817 6.69995 8.0002 6.69995C7.28223 6.69995 6.7002 7.28198 6.7002 7.99995C6.7002 8.71792 7.28223 9.29995 8.0002 9.29995Z"
          stroke-miterlimit="10"
          stroke-linecap="round"
          fill="currentColor"
        />
        <path
          d="M5.24986 10.75C3.72986 9.23 3.72986 6.77 5.24986 5.25"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M10.75 5.25C12.27 6.77 12.27 9.23 10.75 10.75"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M3.41996 12.58C0.889961 10.05 0.889961 5.93997 3.41996 3.40997"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M12.5801 3.41998C15.1101 5.94998 15.1101 10.06 12.5801 12.59"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </g>
    ),
    viewBox: '0 0 16 16',
    stroke: 'currentColor',
    strokeWidth: '1',
  },
  rtiPaused: {
    elements: (
      <>
        <circle cx="12" cy="12" r="1.3" class="cls-2"></circle>
        <path
          d="M12 13.8c-.99 0-1.8-.81-1.8-1.8s.81-1.8 1.8-1.8 1.8.81 1.8 1.8-.81 1.8-1.8 1.8m0-2.59c-.44 0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8M9.25 15.25a.47.47 0 0 1-.35-.15 4.4 4.4 0 0 1 0-6.21c.2-.2.51-.2.71 0s.2.51 0 .71a3.392 3.392 0 0 0 0 4.79c.2.2.2.51 0 .71-.1.1-.23.15-.35.15Z"
          class="cls-2"
        ></path>
        <path
          d="M7.42 17.08a.47.47 0 0 1-.35-.15c-2.72-2.72-2.72-7.15 0-9.87.2-.2.51-.2.71 0s.2.51 0 .71a5.993 5.993 0 0 0 0 8.46c.2.2.2.51 0 .71-.1.1-.23.15-.35.15Z"
          class="cls-2"
        ></path>
        <path
          id="Group_10588"
          d="M18 12c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6m-.9 8.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-5.1c0-.5.4-.9.9-.9s.9.4.9.9zm3.5 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-5.1c0-.5.4-.9.9-.9s.9.4.9.9z"
          class="cls-2"
          data-name="Group 10588"
        ></path>
        <path
          d="M17.88 11H18c.31 0 .61.03.91.07-.2-1.46-.85-2.88-1.97-4-.2-.2-.51-.2-.71 0s-.2.51 0 .71c.91.91 1.45 2.05 1.65 3.23ZM15.34 11.52c.31-.13.64-.23.97-.31-.15-.85-.55-1.66-1.21-2.31-.2-.2-.51-.2-.71 0s-.2.51 0 .71c.54.54.85 1.22.95 1.92Z"
          class="cls-2"
        ></path>
      </>
    ),
    strokeWidth: '1',
    viewBox: '0 0 24 24',
  },
  pause: {
    elements: (
      <>
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path d="M18 12c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-.9 8.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-5.1c0-.5.4-.9.9-.9s.9.4.9.9v5.1zm3.5 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-5.1c0-.5.4-.9.9-.9s.9.4.9.9v5.1z"></path>
      </>
    ),
    fill: 'currentColor',
  },
  expand: {
    elements: (
      <>
        <path d="M15.15 2.15002C15.24 2.06002 15.37 2 15.5 2H22V8.5C22 8.78 21.78 9 21.5 9C21.22 9 21 8.78 21 8.5V3H15.5C15.22 3 15 2.78 15 2.5C15 2.36 15.06 2.24002 15.15 2.15002Z" />
        <path d="M21.85 15.15C21.94 15.24 22 15.37 22 15.5L22 22L15.5 22C15.22 22 15 21.78 15 21.5C15 21.22 15.22 21 15.5 21L21 21L21 15.5C21 15.22 21.22 15 21.5 15C21.64 15 21.76 15.06 21.85 15.15Z" />
        <path
          d="M14.4199 9.58002L20.78 3.21997"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.4197 14.4199L20.7798 20.78"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M8.84998 21.85C8.75998 21.94 8.63 22 8.5 22H2V15.5C2 15.22 2.22 15 2.5 15C2.78 15 3 15.22 3 15.5V21H8.5C8.78 21 9 21.22 9 21.5C9 21.64 8.93998 21.76 8.84998 21.85Z" />
        <path d="M2.15002 8.84998C2.06002 8.75998 2 8.63 2 8.5L2 2L8.5 2C8.78 2 9 2.22 9 2.5C9 2.78 8.78 3 8.5 3L3 3L3 8.5C3 8.78 2.78 9 2.5 9C2.36 9 2.24002 8.93998 2.15002 8.84998Z" />
        <path
          d="M9.58026 14.4199L3.22021 20.78"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.58008 9.58002L3.22003 3.21997"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </>
    ),
    stroke: 'currentColor',
    strokeWidth: '1',
  },
  pickUpOnly: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM4.46969 11.5303C4.1768 11.2374 4.1768 10.7626 4.46969 10.4697L9.18936 5.75H6.00002C5.58581 5.75 5.25002 5.41422 5.25002 5C5.25002 4.58579 5.58581 4.25 6.00002 4.25L11 4.25C11.4142 4.25 11.75 4.58579 11.75 5V10C11.75 10.4142 11.4142 10.75 11 10.75C10.5858 10.75 10.25 10.4142 10.25 10V6.81067L5.53035 11.5303C5.23746 11.8232 4.76258 11.8232 4.46969 11.5303Z"
        fill-opacity="0.95"
      />
    ),
    viewBox: '0 0 16 16',
    fill: 'currentColor',
  },
  setDownOnly: {
    elements: (
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM3.46967 3.46967C3.76256 3.17678 4.23744 3.17678 4.53033 3.46967L9.25 8.18934V5C9.25 4.58579 9.58579 4.25 10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V10C10.75 10.4142 10.4142 10.75 10 10.75H5C4.58579 10.75 4.25 10.4142 4.25 10C4.25 9.58579 4.58579 9.25 5 9.25H8.18934L3.46967 4.53033C3.17678 4.23744 3.17678 3.76256 3.46967 3.46967Z"
        fill-opacity="0.95"
      />
    ),
    viewBox: '0 0 16 16',
    fill: 'currentColor',
  },
  destination: {
    elements: (
      <path d="M12 12.0001L9.64999 9.65009L10.36 8.94006L11.51 10.0901V5.30005H12.51V10.0901L13.66 8.94006L14.37 9.65009L12.02 12.0001H12ZM12 13.7001C10.62 13.7001 9.5 14.8201 9.5 16.2001C9.5 17.5801 10.62 18.7001 12 18.7001C13.38 18.7001 14.5 17.5801 14.5 16.2001C14.5 14.8201 13.38 13.7001 12 13.7001Z" />
    ),
    stroke: 'currentColor',
    strokeWidth: '1.5',
  },
  doubleChevron: {
    elements: (
      <path
        class="st0"
        d="M16 16.8c-.1 0-.3 0-.4-.1L11 12.1l4.6-4.6c.2-.2.5-.2.7 0s.2.5 0 .7l-3.9 3.9 3.9 3.9c.2.2.2.5 0 .7 0 .1-.2.1-.3.1zm-4.6-.1c.2-.2.2-.5 0-.7l-3.9-3.9 3.9-3.9c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-4.6 4.6 4.6 4.6c.1.1.2.1.4.1s.2 0 .3-.1z"
      ></path>
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  caution: {
    elements: (
      <path
        opacity="0.12"
        d="M68.424 39.5568L7.06719 -48.0749C4.44007 -51.8442 0.0956198 -53.8465 -4.46419 -53.4476C-9.02399 -53.0487 -12.9547 -50.3223 -14.8874 -46.1541L-60.095 50.8007C-62.0277 54.9689 -61.614 59.6976 -58.9868 63.4668C-56.3597 67.2361 -52.0153 69.2384 -47.4555 68.8395L59.1089 59.5163C63.6687 59.1174 67.5995 56.3911 69.5321 52.2229C71.4648 48.0547 71.0511 43.326 68.424 39.5568ZM-6.91553 -16.3056C-7.18887 -19.4299 -4.8773 -22.1851 -1.75299 -22.4585C1.37132 -22.7318 4.12621 -20.4198 4.39956 -17.2955L7.84961 22.1387C8.12295 25.263 5.81129 28.0172 2.68698 28.2906C-0.437336 28.5639 -3.19213 26.253 -3.46548 23.1287L-6.91553 -16.3056ZM10.4923 48.4547C9.02828 50.1994 6.99108 51.2278 4.71118 51.4273C2.43127 51.6267 0.239057 50.8833 -1.4983 49.5037C-3.23565 48.1241 -4.27221 46.0019 -4.47167 43.7219C-4.56771 42.6242 -4.40305 41.5886 -4.08427 40.3695C-3.75072 39.3193 -3.24085 38.3392 -2.54737 37.5127C-0.38988 34.9415 3.25905 33.8568 6.50156 34.9346C7.55179 35.2681 8.53234 35.7776 9.35879 36.4711C10.1852 37.1646 10.942 38.0339 11.3684 39.0176C11.8867 40.0784 12.2286 41.0696 12.3321 42.2518C12.5315 44.5317 11.7874 46.7247 10.4079 48.4621L10.4923 48.4547Z"
        fill-opacity="0.95"
      />
    ),
    viewBox: '0 0 71 48',
    fill: '#531313',
  },
  union: {
    elements: (
      <>
        <path
          d="M48.6953 -12L5.19531 63.3438L0 60.3438L43.5 -15L48.6953 -12ZM61.6953 -12L18.1953 63.3438L13 60.3438L56.5 -15L61.6953 -12ZM74.6953 -12L31.1953 63.3438L26 60.3438L69.5 -15L74.6953 -12ZM87.6953 -12L44.1953 63.3438L39 60.3438L82.5 -15L87.6953 -12ZM100.695 -12L57.1953 63.3438L52 60.3438L95.5 -15L100.695 -12ZM113.695 -12L70.1953 63.3438L65 60.3438L108.5 -15L113.695 -12ZM126.695 -12L83.1953 63.3438L78 60.3438L121.5 -15L126.695 -12ZM139.695 -12L96.1953 63.3438L91 60.3438L134.5 -15L139.695 -12ZM152.695 -12L109.195 63.3438L104 60.3438L147.5 -15L152.695 -12ZM165.695 -12L122.195 63.3438L117 60.3438L160.5 -15L165.695 -12Z"
          fill="url(#paint0_linear_6424_2885)"
          fill-opacity="0.95"
        />
        <defs>
          <linearGradient
            id="paint0_linear_6424_2885"
            x1="0"
            y1="24.1719"
            x2="165.695"
            y2="24.1719"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#663F00" stop-opacity="0" />
            <stop offset="1" stop-color="#663F00" stop-opacity="0.12" />
          </linearGradient>
        </defs>
      </>
    ),
    viewBox: '0 0 136 48',
    fill: 'currentColor',
  },
  majorStops: {
    elements: (
      <path d="M12.5 13.6v-3.1c1.1-.2 2-1.2 2-2.4 0-1.4-1.1-2.5-2.5-2.5S9.5 6.7 9.5 8.1c0 1.2.9 2.2 2 2.4v3.1c-1.1.2-2 1.2-2 2.4 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-1.2-.9-2.2-2-2.4z"></path>
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  allStops: {
    elements: (
      <path d="M12.5 16.9v-1c.9-.2 1.5-1 1.5-1.9 0-.9-.6-1.7-1.5-1.9V11c.9-.2 1.5-1 1.5-1.9 0-1.1-.6-1.9-1.5-2.1V6c1.1-.2 2-1.2 2-2.4C14.5 2.1 13.4 1 12 1S9.5 2.1 9.5 3.5c0 1.2.9 2.2 2 2.5v1c-.9.2-1.5 1-1.5 1.9 0 .9.6 1.7 1.5 1.9V12c-.9.2-1.5 1-1.5 1.9 0 .9.6 1.7 1.5 1.9v1c-1.1.2-2 1.2-2 2.5 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-1.2-.9-2.2-2-2.4zm-1.5-8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm0 5c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"></path>
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  calendar: {
    elements: (
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="st0"
        d="M12.5,11.1v4.1c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-2.9l-0.3,0.3c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7   l1.2-1.2c0.1-0.1,0.4-0.2,0.5-0.1C12.4,10.7,12.5,10.9,12.5,11.1z M20,6.5h-1.5V6c0-0.8-0.7-1.5-1.5-1.5S15.5,5.2,15.5,6v0.5h-7V6   c0-0.8-0.7-1.5-1.5-1.5S5.5,5.2,5.5,6v0.5H4C3.7,6.5,3.5,6.7,3.5,7v12c0,0.3,0.2,0.5,0.5,0.5h16c0.3,0,0.5-0.2,0.5-0.5V7   C20.5,6.7,20.3,6.5,20,6.5z M16.5,6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2c0,0.3-0.2,0.5-0.5,0.5S16.5,8.3,16.5,8V6z M6.5,6   c0-0.3,0.2-0.5,0.5-0.5S7.5,5.7,7.5,6v2c0,0.3-0.2,0.5-0.5,0.5S6.5,8.3,6.5,8V6z M19.5,18.5h-15v-11h1V8c0,0.8,0.7,1.5,1.5,1.5   S8.5,8.8,8.5,8V7.5h7V8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V7.5h1V18.5z"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  emptyState: {
    elements: (
      <>
        <g clip-path="url(#clip0_2965_15969)">
          <path
            d="M36.0977 11.5945C21.5993 11.5945 9.8501 23.3648 9.8501 37.8773C9.8501 52.3898 21.5993 64.1601 36.0977 64.1601C50.5962 64.1601 62.3454 52.3898 62.3454 37.8773C62.3454 23.3648 50.5962 11.5945 36.0977 11.5945ZM36.0977 57.8672C25.0728 57.8672 16.136 48.9164 16.136 37.8773C16.136 26.8383 25.0728 17.8875 36.0977 17.8875C47.1227 17.8875 56.0595 26.8383 56.0595 37.8773C56.0595 48.9164 47.1227 57.8672 36.0977 57.8672Z"
            fill="#D0DFA7"
          ></path>
          <path
            d="M37.8492 62.4164C52.3477 62.4164 64.0969 50.646 64.0969 36.1335C64.0969 21.621 52.3477 9.85074 37.8492 9.85074C23.3508 9.85074 11.6016 21.621 11.6016 36.1335C11.6016 50.646 23.3508 62.4164 37.8492 62.4164Z"
            stroke="#272A2E"
            stroke-width="1.40625"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M65.6014 60.9116L78.8342 74.1726C79.4459 74.7843 79.4459 75.7827 78.8342 76.3944L75.5436 79.6921C74.9318 80.3109 73.9334 80.3109 73.3147 79.6921L60.0818 66.4312C59.4701 65.8194 59.4701 64.821 60.0818 64.2093L63.3725 60.9116C63.9842 60.2929 64.9826 60.2929 65.6014 60.9116Z"
            fill="#D0DFA7"
          ></path>
          <path
            d="M37.8484 56.1164C48.8734 56.1164 57.8102 47.1656 57.8102 36.1266C57.8102 25.0875 48.8734 16.1367 37.8484 16.1367C26.8234 16.1367 17.8867 25.0875 17.8867 36.1266C17.8867 47.1656 26.8234 56.1164 37.8484 56.1164Z"
            stroke="#272A2E"
            stroke-width="0.703125"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M60.9539 64.6804L74.1867 77.9414C74.7984 78.5601 75.7969 78.5601 76.4156 77.9414L79.7062 74.6437C80.318 74.032 80.318 73.0336 79.7062 72.4218L66.4734 59.1609C65.8617 58.5422 64.8633 58.5422 64.2445 59.1609L60.9539 62.4586C60.3422 63.0703 60.3422 64.0687 60.9539 64.6804Z"
            stroke="#272A2E"
            stroke-width="1.40625"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M38.0175 29.7563C37.7573 29.5102 37.6659 29.2149 37.6659 28.9477C37.6659 27.7453 39.5151 27.668 39.5151 26.6555C39.5151 26.1844 39.1636 25.9172 38.5519 25.9172C38.0175 25.9172 37.6519 26.1844 37.6519 26.7188C37.6519 27.0071 37.4128 27.2461 37.1245 27.2461C36.8362 27.2461 36.5972 27.0071 36.5972 26.7188C36.5972 25.6289 37.3214 24.9821 38.5448 24.9821C39.7683 24.9821 40.5417 25.5867 40.5417 26.6555C40.5417 28.1953 38.7206 28.3078 38.7206 28.8774C38.7206 28.9547 38.7487 29.011 38.819 29.1094C38.8753 29.1938 38.9034 29.2922 38.9034 29.3977C38.9034 29.7211 38.6292 29.911 38.3901 29.911C38.2355 29.911 38.1159 29.8547 38.0175 29.7563ZM38.362 31.6125C37.9612 31.6125 37.7292 31.4086 37.7292 30.9938C37.7292 30.5789 37.9612 30.3539 38.362 30.3539C38.7628 30.3539 38.9808 30.5649 38.9808 30.9938C38.9808 31.4227 38.7628 31.6125 38.362 31.6125Z"
            fill="black"
          ></path>
          <path
            d="M43.1016 42.5602C42.7992 42.0609 42.7711 41.5477 42.8836 41.1258C43.3969 39.2203 46.357 39.8883 46.786 38.2852C46.9828 37.5469 46.5399 36.9703 45.5695 36.7102C44.7258 36.4852 44.0367 36.7523 43.8117 37.5961C43.6922 38.0461 43.2141 38.3273 42.757 38.2078C42.3 38.0883 42.0258 37.6102 42.1453 37.1531C42.6094 35.4305 44.0297 34.7133 45.9633 35.2266C47.8969 35.7398 48.8672 37.0266 48.4102 38.7211C47.7563 41.1539 44.8242 40.5633 44.5781 41.4703C44.543 41.5898 44.5641 41.6953 44.6344 41.8711C44.6906 42.0328 44.6906 42.1945 44.6485 42.3633C44.5078 42.8766 43.9946 43.0594 43.6149 42.9609C43.3758 42.8977 43.2 42.75 43.0875 42.5602H43.1016ZM42.8555 45.6539C42.2227 45.4852 41.9414 45.0703 42.1242 44.4023C42.3071 43.7344 42.7571 43.4883 43.3899 43.657C44.0227 43.8258 44.2828 44.2547 44.1 44.9297C43.9172 45.6047 43.4883 45.8156 42.8555 45.6469V45.6539Z"
            fill="black"
          ></path>
          <path
            d="M29.3346 40.4507C28.9197 40.2187 28.6947 39.8742 28.6033 39.5297C28.1885 37.9828 30.544 37.2445 30.1994 35.9437C30.0377 35.339 29.4893 35.1211 28.7018 35.332C28.0127 35.5148 27.6401 35.9859 27.8229 36.675C27.9213 37.0406 27.6963 37.4343 27.3307 37.5328C26.965 37.6312 26.5713 37.4062 26.4729 37.0406C26.1002 35.6414 26.8104 34.5515 28.3783 34.1367C30.0025 33.7008 31.1557 34.2211 31.5213 35.5992C32.0486 37.575 29.7424 38.3554 29.9393 39.0867C29.9674 39.1851 30.0236 39.2484 30.1432 39.3468C30.2486 39.4382 30.319 39.5508 30.3541 39.6843C30.4666 40.0992 30.1783 40.4437 29.8689 40.5281C29.6721 40.5773 29.4963 40.5492 29.3346 40.4578V40.4507ZM30.4174 42.7289C29.9041 42.8695 29.5385 42.6867 29.3908 42.1453C29.2432 41.5898 29.4682 41.2453 29.9815 41.1047C30.4947 40.964 30.8533 41.1609 31.001 41.7164C31.1486 42.2718 30.9307 42.5882 30.4174 42.7289Z"
            fill="black"
          ></path>
          <path
            d="M64.3356 59.0695L58.4575 53.1844"
            stroke="#272A2E"
            stroke-width="1.40625"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M54.9912 56.6578L60.8693 62.543"
            stroke="#272A2E"
            stroke-width="1.40625"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_2965_15969">
            <rect width="90" height="90" fill="white"></rect>
          </clipPath>
        </defs>
      </>
    ),
    viewBox: '0 0 90 90',
  },
  serviceInfo: {
    elements: (
      <path
        d="M8.5 0C3.81 0 0 3.81 0 8.5C0 13.19 3.81 17 8.5 17C13.19 17 17 13.19 17 8.5C17 3.81 13.19 0 8.5 0ZM8.5 16C4.36 16 1 12.64 1 8.5C1 4.36 4.36 1 8.5 1C12.64 1 16 4.36 16 8.5C16 12.64 12.64 16 8.5 16ZM9.69 12.23L9.48 13.02C9.39 13.36 9.17 13.65 8.86 13.82C8.66 13.94 8.43 14 8.2 14C8.08 14 7.97 13.99 7.86 13.96C7.16 13.77 6.74 13.05 6.92 12.34L8.2 7.58C8.22 7.5 8.21 7.41 8.17 7.34C8.13 7.27 8.06 7.21 7.97 7.19C7.88 7.17 7.8 7.18 7.73 7.22C7.66 7.26 7.6 7.33 7.58 7.42C7.51 7.69 7.24 7.85 6.97 7.77C6.7 7.7 6.54 7.42 6.62 7.16C6.71 6.82 6.93 6.53 7.24 6.36C7.55 6.19 7.9 6.14 8.24 6.23C8.58 6.32 8.86 6.54 9.04 6.85C9.22 7.16 9.26 7.51 9.17 7.85L7.89 12.61C7.87 12.69 7.88 12.78 7.92 12.85C7.96 12.92 8.03 12.98 8.11 13C8.19 13.02 8.28 13.01 8.35 12.97C8.42 12.93 8.48 12.86 8.5 12.78L8.71 11.99C8.78 11.72 9.05 11.57 9.32 11.64C9.59 11.71 9.75 11.99 9.67 12.25L9.69 12.23ZM7.95 4.11C8.05 3.74 8.38 3.5 8.74 3.5C8.81 3.5 8.88 3.5 8.95 3.53C9.39 3.65 9.65 4.1 9.53 4.54C9.43 4.91 9.1 5.15 8.74 5.15C8.67 5.15 8.6 5.15 8.53 5.12C8.09 5 7.83 4.55 7.95 4.11Z"
        fill="white"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
  cross: {
    elements: (
      <path
        d="M7 7L17 17M17 7L7 17"
        stroke="black"
        stroke-opacity="0.95"
        stroke-linecap="round"
      />
    ),
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  },
} satisfies Record<string, SvgDefinition>;

export type SvgName = keyof typeof SvgPaths;
